module.exports = __webpack_public_path__ + "static/media/dailykos_story_2016_3_11_1499735_-Trump-Rally-No-Joking-Matter_plot.a534c288.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/dailykos_story_2016_3_11_1499735_-Trump-Rally-No-Joking-Matter_plot.png
// module id = 385
// module chunks = 0